import { cn } from '@/lib/utils'

const loaderClass = {
  default: 'border-white',
  dark: 'border-white',
  light: 'border-primary-500',
}

const loaderBGClass = {
  default: 'border-primary-500',
  dark: 'border-primary-700',
  light: 'border-primary-100',
}

export const Loader = ({ sizeClassName = 'size-5', type = 'default' }: { sizeClassName?: string; type: 'default' | 'dark' | 'light' }) => {
  return (
    <div className={cn('relative flex animate-spin items-center justify-center rounded-full border-2', loaderBGClass[type], sizeClassName)}>
      <div className={cn('absolute flex items-center justify-center rounded-full border-2', sizeClassName, loaderClass[type])} style={{ clipPath: 'xywh(50% 0% 50% 50%)' }} />
    </div>
  )
}
